// Synthetic, fictional scenario data only. No real organisations, people or evidence.
export const SCENARIO_REF = "NG-4471";

export const ORGS = [
  { id: "carrier", label: "Meridian Carriers", role: "Carrier" },
  { id: "port", label: "Northgate Port Ops", role: "Operator" },
  { id: "insurer", label: "Atlas Mutual", role: "Insurer" },
  { id: "customer", label: "Halverson Trading", role: "Customer" },
  { id: "inspect", label: "Coastline Inspectorate", role: "Inspectorate" },
];

export const TIMELINE = [
  { time: "09:12", event: "Seal anomaly flagged on consignment NG-4471.", fault: "Evidence is held across separate parties." },
  { time: "09:14", event: "The operations dashboard shows a hold.", fault: "A dashboard can show the problem — it cannot move it." },
  { time: "09:18", event: "The carrier cannot see the inspection evidence.", fault: "Access is not authority." },
  { time: "09:23", event: "The insurer needs confirmation of one policy condition.", fault: "Sharing the full document exposes far too much." },
  { time: "09:29", event: "The customer asks for a release status.", fault: "No single role owns the decision." },
  { time: "09:36", event: "The team begins emailing documents and calling contacts.", fault: "Coordination drops into email and phone." },
  { time: "09:44", event: "Conflicting information; unclear who may decide.", fault: "Nobody knows who can safely decide." },
  { time: "09:52", event: "The decision is delayed — or settled in an undocumented side channel.", fault: "The real decision moves outside the system." },
];

export const OLD_CONCLUSION =
  "The old stack can show the problem. It cannot safely move the decision forward.";

export const COMPARISON = [
  { think: "Access to a portal", need: "Authority to decide this action now" },
  { think: "More data", need: "The minimum proof required" },
  { think: "An alert", need: "A routed decision request" },
  { think: "An audit log", need: "A receipt of the actual outcome" },
  { think: "Someone to call", need: "A known, accountable role" },
];

export const PROOF_ITEMS = [
  { id: "p1", label: "Inspection validity", holder: "Coastline Inspectorate" },
  { id: "p2", label: "Insurance condition met", holder: "Atlas Mutual" },
  { id: "p3", label: "Seal-status exception", holder: "Meridian Carriers" },
];

export const CUSTODIANS = [
  { holder: "Coastline Inspectorate", holds: "Inspection record", shared: "Validity, by reference" },
  { holder: "Atlas Mutual", holds: "Policy schedule", shared: "One condition, confirmed" },
  { holder: "Meridian Carriers", holds: "Seal event log", shared: "Exception status only" },
];

export const AUTHORITY_ROLE = "Duty Release Authority · Northgate Port Operations";

export const DECISIONS = {
  approve: { label: "Approve — conditional release", outcome: "Conditional release authorised", tone: "approved" },
  refuse: { label: "Refuse", outcome: "Release refused — consignment held", tone: "refused" },
  escalate: { label: "Escalate", outcome: "Escalated to senior duty authority", tone: "neutral" },
  check: { label: "Request further check", outcome: "Further inspection requested", tone: "neutral" },
};

export const GOVERNED_STEPS = [
  { n: 1, label: "Bounded request", detail: "Conditional release decision" },
  { n: 2, label: "Purpose", detail: "Determine whether the consignment may proceed" },
  { n: 3, label: "Required proof", detail: "Only the minimum needed to decide" },
  { n: 4, label: "Route to authority", detail: AUTHORITY_ROLE },
  { n: 5, label: "Evidence custody", detail: "Evidence stays with its holder" },
  { n: 6, label: "Decision", detail: "An entitled role decides" },
  { n: 7, label: "Receipt", detail: "Proof of the outcome" },
];

export const WITHOUT_KATLAS = [
  "Chase people for answers.",
  "Send too much information.",
  "Guess who can decide.",
  "Reconstruct events later.",
  "Accept delay or risky workarounds.",
];

export const WITH_KATLAS = [
  "Request a specific decision.",
  "Share the minimum proof required.",
  "Route action to the proper authority.",
  "Keep evidence under its holder’s control.",
  "Retain a clear receipt of the outcome.",
];

export const CHANGE_CONCLUSION =
  "Coordinate action across organisations without centralising sensitive evidence, granting blanket access, or relying on undocumented workarounds.";

export const PATTERNS = [
  { title: "Border & freight release", line: "A held consignment needs a conditional release decision across carrier, port and insurer." },
  { title: "AI-supported operational escalation", line: "An automated check raises an exception that a human authority must own and decide." },
  { title: "Patient, supplier or infrastructure handover", line: "A handover proceeds only when the entitled role approves, with minimum proof shared." },
];

export const CAR = [
  { k: "Custody", v: "controls the evidence." },
  { k: "Authority", v: "governs the action." },
  { k: "Receipts", v: "prove what happened." },
];
